import React, { useState, useCallback } from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { ArrowLeftRight } from 'lucide-react';
import '@/components/ui/ComparisonSlider.scss';
import { useMediaQuery } from 'react-responsive';

interface ComparisonSliderProps {
  text: string;
  imagePath: string;
  textRight?: boolean;
}

const ComparisonSlider = ({ text, imagePath, textRight = false }: ComparisonSliderProps) => {
  const isMobile = useMediaQuery({ query: '(max-width: 890px)' });

  const getOpen = () => isMobile ? (textRight ? 8 : 2) : (textRight ? 20 : 5);
  const getClosed = () => isMobile ? 95 : (textRight ? 95 : 85);

  const [position, setPosition] = useState<number>(getOpen);

  const handleToggle = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setPosition((prev) => (prev < 50 ? getClosed() : getOpen()));
  }, [isMobile, textRight]);

  return (
    <div className="comp-slider" data-text-right={textRight}>
      <ReactCompareSlider
        onlyHandleDraggable={true}
        changePositionOnHover={false}
        position={position}
        onPositionChange={setPosition}
        itemOne={<ReactCompareSliderImage src={imagePath} className="comp-slider__img--color" />}
        itemTwo={
          <div className="comp-slider__reveal">
            <ReactCompareSliderImage src={imagePath} className="comp-slider__img--gray" />
            <div className="comp-slider__overlay">
              <div className="comp-slider__text">
                <p>{text}</p>
              </div>
            </div>
          </div>
        }
        handle={
          <div className="comp-slider__handle">
            <div className="comp-slider__handle-line" />
            <div className="comp-slider__handle-knob" onClick={handleToggle} role="button">
              <ArrowLeftRight size={16} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default ComparisonSlider;